export default __webpack_public_path__ + "static/sweatshirtHeader-e6d091daf66555c8cfd14a19f63d4af2.jpg";